import { userAgentParser } from '@common/UserAgentParser/UserAgentParser'

/**
 * A userAgent alapján ez Windows?
 * @param ua - UserAgent.
 */
export default function isWindows (ua: string): boolean {
  return userAgentParser.isWindows(ua)
}
